import axios from 'axios';
import { commonTernary, isWebComponentFlow } from '../components/commonCode';
import { wcApiUrl } from '../WebComponents/commonComponents/customUtils';

export const getAccessToken = async ({ env, isWCFlow }) => {
  const url = commonTernary(
    isWCFlow,
    wcApiUrl(env).REACT_APP_TOKEN_SERVICE_URL,
    process.env.REACT_APP_TOKEN_SERVICE_URL
  );
  const headers = {
    'Content-Type': 'application/json',
    'x-api-key': process.env.REACT_APP_X_API_KEY,
  };
  const wcPayload = isWCFlow ? { clientId: wcApiUrl(env).REACT_APP_CLIENT_ID[env] } : undefined;
  const request = isWCFlow ? axios.post(url, wcPayload, { headers }) : axios.get(url, { headers });
  const { data } = await request;
  return data?.description?.customAccessToken;
};

// export const sspLogoutCall = async (token, customerNumber, language, uuid) => {
//   let response = null;
//   try {
//     response = await axios.post(
//       process.env.REACT_APP_EXPRESS_SSP_SESSION_LOGOUT,
//       {
//         customerNumber,
//         language: language === 'EN' ? 'eng' : 'esp',
//         uuid,
//       },
//       {
//         headers: {
//           Authorization: `Bearer ${token}`,
//         },
//       }
//     );
//   } catch (e) {
//     return e.response;
//   }
//   return response;
// };
export const getInitiateUiData = async (accessToken, setInitiateUiResponse) => {
  try {
    const response = await axios.get(process.env.REACT_APP_AUTHENTICATED_INITIATEUI, {
      headers: {
        Authorization: `Bearer ${accessToken}`,
        appid: 'sales',
      },
    });
    setInitiateUiResponse(response?.data);

    return response?.data;
  } catch (error) {
    console.error('Error calling initiateUI API:', error);
    return null;
  }
};
